import styled from "styled-components";

export const PartyParent = styled.main`
  width: 95%;
  height: 80%;
  background: #fff;
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  text-align: center;
  }
  `;